/**
 * FILE UPLOAD SECURITY CONSTANTS
 *
 * Security configuration for file uploads including allowed types,
 * size limits, image processing, and malicious content detection.
 */

import { MALICIOUS_PATTERNS } from './fieldValidation.constants';

// FILE UPLOAD SECURITY CONFIGURATION
export const FILE_UPLOAD_SECURITY = {
  // Allowed image types and extensions
  ALLOWED_IMAGE_TYPES: {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/webp': ['.webp'],
  } as const,

  // File size limits
  MAX_FILE_SIZE: 2 * 1024 * 1024, // 2MB

  // Image dimension limits
  MAX_IMAGE_DIMENSIONS: {
    width: 2000,
    height: 2000,
  },

  // Compression settings
  COMPRESSION_SETTINGS: {
    maxWidth: 800,
    maxHeight: 800,
    quality: 0.8, // 80% quality
  },

  // Malicious content patterns for file scanning
  FILE_MALICIOUS_PATTERNS: [
    ...MALICIOUS_PATTERNS.SCRIPT_TAGS,
    ...MALICIOUS_PATTERNS.JAVASCRIPT_PROTOCOL,
    ...MALICIOUS_PATTERNS.EVENT_HANDLERS,
    /<%/, // ASP/JSP code
    /<\?php/i, // PHP code
  ] as const,
} as const;
